import React, { useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { CTALink } from '@components/CTALink';
import { ourStoryPageData } from '@data-ts/pages/our-story';
import { SectionWrapper, TextBox, TextWrapper, StyledFlex, StyledTextPairing, SectionContainer } from './JoinOurTeam.styles';
import { LazyLoadWrapper } from '@components/LazyLoadWrapper';

export const JoinOurTeam = () => {
  const { joinOurTeam } = ourStoryPageData;
  const [isVisible, setIsVisible] = useState(false);
  return (
    <SectionWrapper id="our_story_join_our_team" paddingBottom={[5, 0]}>
      <LazyLoadWrapper afterLoad={() => setIsVisible(true)}>
        <></>
      </LazyLoadWrapper>
      <TextBox>
        <TextWrapper>
          <StyledTextPairing
            title={joinOurTeam.title}
            titleVariant="hed56"
            titleColor="neutra6"
            titleTagName="h2"
            body={ReactHtmlParser(joinOurTeam.body)}
            bodyVariant="dek20"
            bodyColor="neutra5"
            bodyMaxWidth="420px"
          />
          <StyledFlex alignItems="center" paddingY={[6]}>
            <CTALink
              id="ourStoryExploreCareers"
              href={ourStoryPageData.allPostionsCta}
              variant="primary"
              hasChevron={true}
              typography={'featureHed17'}
            >
              {joinOurTeam.exploreCareers}
            </CTALink>
          </StyledFlex>
        </TextWrapper>
      </TextBox>
      <SectionContainer backgroundImage="our-story/join-team/join-us.jpg" isVisible={isVisible} />
    </SectionWrapper>
  );
};
